import { render, staticRenderFns } from "./TabelaReinserirValoresItens.vue?vue&type=template&id=439b6cb8"
import script from "./TabelaReinserirValoresItens.vue?vue&type=script&lang=js"
export * from "./TabelaReinserirValoresItens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports